import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import type { GetCallCampaignPayload } from './GetCallCampaignPayload';
import type { GetCallCampaignResponse } from './GetCallCampaignResponse';

interface GetCallCampaignFunctionParams {
  payload: GetCallCampaignPayload;
  snowplowData?: string;
}

interface GetCallCampaignFunctionFactoryParams {
  endpoint: string;
  httpCall?: IHttpCall;
}

export interface GetCallCampaignFunction {
  (
    params: GetCallCampaignFunctionParams,
  ): Promise<IHttpResponse<GetCallCampaignResponse>>;
}

export function getCallCampaignFunctionFactory({
  endpoint,
  httpCall = fetchBasedCall,
}: GetCallCampaignFunctionFactoryParams): GetCallCampaignFunction {
  return ({ payload, snowplowData = '' }) => {
    const request: IHttpRequest<GetCallCampaignPayload> = {
      url: `${endpoint}/call/campaign`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'snowplow-data': snowplowData,
      },
      body: payload,
    };

    return httpCall<GetCallCampaignPayload, GetCallCampaignResponse>(request);
  };
}
